import InitialVisitImageFlow from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/initialVisit/images/InitialVisitImageFlow';
import InitialBodyContactOwnerForm from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/initialVisit/InitialBodyContactOwnerForm';
import InitialBodyRealOwnerForm from '@/modules/adjusterReportModules/IncidentParticipants/components/damaged/initialVisit/InitialBodyRealOwnerForm';
import InitialVIsitShowVehicleInformation from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/initialVisit/InitialVIsitShowVehicleInformation';
import PartOne from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/initialVisit/partOne/PartOne';
import InitialPartTwo from '@/modules/adjusterReportModules/IncidentParticipants/components/vehicleInformation/components/initialVisit/partTwo/PartTwo';

import InitialVisitAdditionalImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/additionalImages/InitialVisitAdditionalImages';
import ShowAdditionalImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/additionalImages/ShowAdditionalImages';
import AdjusterImageEntryTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/AdjusterImageEntryTabs';
import InitialVisitDamagedPoints from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/vehicleImages/damagedPoints/InitialVisitDamagedPoints';
import InitialVisitFlowGuidePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/vehicleImages/flowGuide/InitialVisitFlowGuidePage';
import InitialVisitLocalImagePreviewPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/vehicleImages/InitialVisitLocalImagePreview/InitialVisitLocalImagePreview';
import InitialVisitServerDamagedPointsPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/vehicleImages/InitialVisitServerDamagedPoints/InitialVisitServerDamagedPointsPage';
import InitialVisitImagesShow from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/vehicleImages/InitialVisitServerImagePreview/InitialVisitImagesShow';
import InitialVisitServerImagePreviewPage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/adjusterImages/vehicleImages/InitialVisitServerImagePreview/InitialVisitServerImagePreview';
import InitialVisitCorrectiveImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/correctiveImages/InitialVisitCorrectiveImages';
import InitialVisitCustomerImagesTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/initialVisitCustomerImages/InitialVisitCustomerImagesTabs.tsx';
import InitialVisitImagesTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/initialVisitImagesTabs/InitialVisitImagesTabs';
import InitialVisitSignaturePage from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/images/signature/InitialVisitSignaturePage';
import VehicleInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/InitialVehicleInformation/InitialVehicleInformation';
import InitialVisitAccessory from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitExpert/InitialVisitAccessory/InitialVisitAccessory';
import InitialVisitExpert from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitExpert/InitialVisitExpert';
import VisitForm from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitExpert/VisitForm';
import InitialVisitVehicleShowVisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitExpert/visitInformation/InitialVisitVehicleShowVisitInformation';
import InitialVisitVehicleVisitInformation from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitExpert/visitInformation/InitialVisitVehicleVisitInformation';
import {
  ADJUSTER_IMAGES_PATH,
  DOCUMENTS_PATH,
  INITIAL_VISIT_ACCESSORY_FORM,
  INITIAL_VISIT_ACCESSORY_PATH,
  INITIAL_VISIT_ACCESSORY_PATH_SHOW,
  INITIAL_VISIT_ADDITIONAL_IMAGES_PATH,
  INITIAL_VISIT_ADDITIONAL_IMAGES_PATH_SHOW,
  INITIAL_VISIT_ADJUSTER_PATH,
  INITIAL_VISIT_CORRECTIVE_IMAGES,
  INITIAL_VISIT_CUSTOMER_IMAGES,
  INITIAL_VISIT_DOCUMENT_PATH,
  INITIAL_VISIT_DOCUMENT_PATH_SHOW,
  INITIAL_VISIT_FLOW_TAKE_PHOTO_GUIDE,
  INITIAL_VISIT_FORM_PATH,
  INITIAL_VISIT_FORM_PATH_SHOW,
  INITIAL_VISIT_IMAGE_FLOW_PATH,
  INITIAL_VISIT_INFORMATION_PATH,
  INITIAL_VISIT_LOCAL_IMAGE_PREVIEW,
  INITIAL_VISIT_SERVER_DAMAGED_POINTS_PATH,
  INITIAL_VISIT_SERVER_IMAGE_PREVIEW,
  INITIAL_VISIT_SERVER_IMAGE_PREVIEW_show,
  INITIAL_VISIT_SIGNATURE_PATH,
  INITIAL_VISIT_SIGNATURE_PATH_SHOW,
  INITIAL_VISIT_VEHICLE_IMAGES_PATH,
  ONLY_SHOW_OWNER_INITIAL_INFO_PATH,
  OWNER_CONTACT_INFO_PATH,
  OWNER_INITIAL_INFO_PATH,
  PART_TWO,
  SHOW_INITIAL_VISIT_INFORMATION_PATH,
  VEHICLE_INFO_PATH,
  VEHICLE_INFO_PATH_SHOW,
} from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitLink';
import InitialVisitTabs from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/initialVisitTabs';
import InitialVisitOwnerInfo from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/owner/ownerInfo/InitialVisitOwnerInfo';
import InitialVisitOwnerOnlyShow from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/initialVisit/owner/ownerInfo/InitialVisitOwnerOnlyShow';
import AdjusterDocumentsImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/AdjusterDocumentsImages';
import ShowAdjusterDocumentImages from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/documentImages/ShowAdjusterDocumentImages';
import { VehicleInformationEnum } from '@/modules/adjusterReportModules/IncidentParticipants/types/VehicleInformationType';
import { Outlet, RouteObject } from 'react-router-dom';
import InitialVisitAccessoryFormPage from './initialVisitExpert/InitialVisitAccessory/InitialVisitAccessoryForm';
import { INSURANCE_INFORMATION_PATH } from '@/modules/adjusterReportModules/IncidentParticipants/Links';

export const INITIAL_VISIT_ROUTES: RouteObject[] = [
  {
    path: INSURANCE_INFORMATION_PATH,
    children: [
      {
        index: true,
        element: <InitialVisitTabs />,
      },
      {
        path: OWNER_INITIAL_INFO_PATH,
        element: (
          <InitialVisitOwnerInfo>
            <InitialBodyRealOwnerForm />
          </InitialVisitOwnerInfo>
        ),
      },
      {
        path: OWNER_CONTACT_INFO_PATH,
        element: (
          <InitialVisitOwnerInfo>
            <InitialBodyContactOwnerForm />
          </InitialVisitOwnerInfo>
        ),
      },
      {
        path: ONLY_SHOW_OWNER_INITIAL_INFO_PATH,
        element: <InitialVisitOwnerOnlyShow />,
      },

      {
        path: VEHICLE_INFO_PATH,
        element: (
          <VehicleInformation>
            <Outlet />
          </VehicleInformation>
        ),
        children: [
          {
            index: true,
            element: <PartOne type={VehicleInformationEnum.initial} />,
          },
          {
            path: PART_TWO,
            element: <InitialPartTwo />,
          },
        ],
      },
      {
        path: VEHICLE_INFO_PATH_SHOW,
        element: <InitialVIsitShowVehicleInformation />,
      },
      {
        path: DOCUMENTS_PATH,
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <InitialVisitImagesTabs />,
          },
          {
            path: ADJUSTER_IMAGES_PATH,
            element: <Outlet />,
            children: [
              {
                index: true,
                element: <AdjusterImageEntryTabs />,
              },
              {
                path: INITIAL_VISIT_VEHICLE_IMAGES_PATH,
                children: [
                  {
                    element: <InitialVisitDamagedPoints />,
                    index: true,
                  },
                  {
                    path: INITIAL_VISIT_SERVER_DAMAGED_POINTS_PATH,
                    element: <InitialVisitServerDamagedPointsPage />,
                  },
                  {
                    path: INITIAL_VISIT_FLOW_TAKE_PHOTO_GUIDE,
                    element: <InitialVisitFlowGuidePage />,
                  },
                  {
                    path: INITIAL_VISIT_IMAGE_FLOW_PATH,
                    element: <InitialVisitImageFlow />,
                  },
                  {
                    path: INITIAL_VISIT_LOCAL_IMAGE_PREVIEW,
                    element: <InitialVisitLocalImagePreviewPage />,
                  },
                  {
                    path: INITIAL_VISIT_SERVER_IMAGE_PREVIEW,
                    element: <InitialVisitServerImagePreviewPage />,
                  },
                  {
                    path: INITIAL_VISIT_SERVER_IMAGE_PREVIEW_show,
                    element: <InitialVisitImagesShow />,
                  },
                ],
              },
              {
                path: INITIAL_VISIT_DOCUMENT_PATH,
                element: <AdjusterDocumentsImages userType="initial" />,
              },
              {
                path: INITIAL_VISIT_DOCUMENT_PATH_SHOW,
                element: <ShowAdjusterDocumentImages userType="initial" />,
              },
              {
                path: INITIAL_VISIT_ADDITIONAL_IMAGES_PATH,
                element: <InitialVisitAdditionalImages />,
              },
              {
                path: INITIAL_VISIT_ADDITIONAL_IMAGES_PATH_SHOW,
                element: <ShowAdditionalImages userType="initial" />,
              },
            ],
          },
          {
            path: INITIAL_VISIT_CUSTOMER_IMAGES,
            element: <Outlet />,
            children: [
              {
                index: true,
                element: <InitialVisitCustomerImagesTabs />,
              },
            ],
          },
          {
            path: INITIAL_VISIT_SIGNATURE_PATH,
            element: <InitialVisitSignaturePage editable />,
          },
          {
            path: INITIAL_VISIT_SIGNATURE_PATH_SHOW,
            element: <InitialVisitSignaturePage editable={false} />,
          },
          {
            path: INITIAL_VISIT_CORRECTIVE_IMAGES,
            element: <InitialVisitCorrectiveImages />,
          },
        ],
      },
      {
        path: INITIAL_VISIT_ADJUSTER_PATH,
        children: [
          {
            index: true,
            element: <InitialVisitExpert />,
          },
          {
            path: INITIAL_VISIT_INFORMATION_PATH,
            element: <InitialVisitVehicleVisitInformation />,
          },
          {
            path: SHOW_INITIAL_VISIT_INFORMATION_PATH,
            element: <InitialVisitVehicleShowVisitInformation />,
          },
          {
            path: INITIAL_VISIT_ACCESSORY_PATH,
            children: [
              {
                index: true,
                element: <InitialVisitAccessory />,
              },
              {
                path: INITIAL_VISIT_ACCESSORY_FORM,
                element: <InitialVisitAccessoryFormPage />,
              },
            ],
          },

          {
            path: INITIAL_VISIT_ACCESSORY_PATH_SHOW,
            element: <InitialVisitAccessory isEditable={false} />,
          },

          {
            path: INITIAL_VISIT_FORM_PATH,
            element: <VisitForm isEditable />,
          },
          {
            path: INITIAL_VISIT_FORM_PATH_SHOW,
            element: <VisitForm isEditable={false} />,
          },
        ],
      },
    ],
  },
];
